import { DocumentWorkflowContract } from '@dealstack/frontend/investor/pages/Investment/common/DocumentWorkflowContracts/DocumentWorkflowContract';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

interface Props {
	setIsContinueDisabled: (isContinueDisabled: boolean) => void;
	investorId: string | undefined;
}

export const InvestmentLeaveContracts = ({ setIsContinueDisabled, investorId }: Props) => {
	const { mipId, dealId, investmentWorkflowId } = useRequiredParams(
		'mipId',
		'dealId',
		'investmentWorkflowId'
	);

	if (!investorId) {
		return null;
	}

	return (
		<DocumentWorkflowContract
			setIsContinueDisabled={setIsContinueDisabled}
			dealId={dealId}
			mipId={mipId}
			investorId={investorId}
			investmentWorkflowId={investmentWorkflowId}
			excludeTsaContracts={false}
		/>
	);
};
